import React from "react"
import * as PropTypes from "prop-types"
import Link from "gatsby-link"
import { Helmet } from "react-helmet"
import Markdown from "../../components/Markdown"
import oog from "../../assets/oog-klein.svg"

import style from "./index.module.css";

const propTypes = {
  data: PropTypes.object.isRequired,
}

class Consultancy extends React.Component {
  render() {
    const content = this.props.data.page.edges[0].node
    return (
      <div>
        <Helmet>
          <title>{content.title}</title>
          <meta name="description" content={content.metaDescription} />
          <meta property="og:title" content={content.title} />
          <meta property="og:description" content={content.metaDescription} />
        </Helmet>
        <h1>{content.title}</h1>
        {content.intro.intro &&
          <Markdown className={style.intro} source={content.intro.intro} />
        }
        {content.body.body &&
          <Markdown className={style.article} source={content.body.body} />
        }
        <div className={style.contact}>
          <img className={style.oog} src={oog} width="50" />
          <div className={style.contactText}>
            <div>Interesse of een vraag?</div>
            <div>Neem dan contact met me op.</div>
          </div>
          <Link className={style.contactLink} to="/contact">Naar contact</Link>
        </div>
      </div>
    )
  }
}

Consultancy.propTypes = propTypes

export default Consultancy

export const consultancyPageQuery = graphql`
  query consultancyPageQuery {
    page: allContentfulPageConsultancy {
      edges {
        node {
          title
          metaDescription
          intro {intro}
          body {body}
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/consultancy/index.js